module.exports = __webpack_public_path__ + "media/stylesheets/images/spritesheet-2x-2dbe42dce56e14652d2e97329f42db63.png";